import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import StandardModalV2 from "../../shared/StandardModalV2";

const P2PScreenWrapper = (props) => {
	const fullscreenWrapperRef = useRef();
	const [fullscreenTitleBarActive, setFullscreenTitleBarActive] = useState(false);

	useEffect(() => {
		if (props.fullscreen) {
			fullscreenWrapperRef.current.focus();
		}
		setFullscreenTitleBarActive(false);
	}, [props.fullscreen]);

	const onEscapeAction = (event) => {
		if (event.key === "Escape" || event.type === "click") {
			props.setFullscreenMode(false);
		}
	};

	if (props.fullscreen) {
		return (
			<div
				ref={fullscreenWrapperRef}
				className="P2PDisplayModal_fullscreenWrapper"
				tabIndex={-1}
				onKeyUp={onEscapeAction}
				onClick={onEscapeAction}
			>
				<div
					className="P2PFullscreen_titleBarContainer"
					onMouseEnter={() => setFullscreenTitleBarActive(true)}
					onMouseLeave={() => setFullscreenTitleBarActive(false)}
				>
					<div className={clsx(fullscreenTitleBarActive ? "P2PFullscreen_titleBar" : "P2PFullscreen_titleBar--hidden")}>
						<h2>{props.title}</h2>
						{props.exitButton}
					</div>
				</div>
				{props.children}
			</div>
		);
	} else {
		return (
			<StandardModalV2
				isOpen={props.open}
				close={props.handleClose}
				size="content"
				// isLiveView property is only used when p2p modal is opened
				// for all others there is no need to set the value
				isLiveView={true}
				liveViewReady={props.liveViewReady}
				ariaHideApp={false}
				rootClassName="P2PModal_root"
				contentClassName="P2PModal_content"
			>
				{props.children}
			</StandardModalV2>
		);
	}
};

export default P2PScreenWrapper;
